'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.endOfYear;


// WEBPACK FOOTER //
// ./~/sugar-date/date/endOfYear.js